import React, { Component, useContext, useState, useEffect } from "react";
import Colorer from 'color';
import { ProductContext } from '../context'


export function colorRotater(oldTheme, rotateAngle = 29){
  // const oldTheme = useContext(ProductContext).getTheme();
  let newTextColor = Colorer(oldTheme.colorText).rotate(rotateAngle).hex()
  return ColorThemer(oldTheme, newTextColor);
}






const ColorThemer = (oldTheme, textColor) => {

  // let [state, setState] = useState(29);
  let rotateAngle = 29;

  // const changeTheme = useContext(ProductContext).changeTheme;
  // const oldTheme = useContext(ProductContext).getTheme();
  // let colorSource = Colorer(oldTheme.colorAccent).saturate(0.1).hex();




  let colorAccent =  Colorer(textColor)
  .saturate(0.8)
  .hex();

  let colorText = Colorer(textColor)
  // .negate()
  .rotate(rotateAngle + 30)
  .saturate(0.6)
  .hex();




  // colorAccent: Colorer(colorSource).rgb().rotate(rotateAngle).hex(),
  // colorBg: Colorer(colorSource).rgb().rotate(rotateAngle - 80).negate().hex(),
  // colorBg: Colorer(oldTheme.colorText).rgb().rotate(rotateAngle - 80).negate().hex(),
  let colorBg = Colorer(colorText).luminosity() > 0.0065 ?
    Colorer(oldTheme.colorText)
    .rgb()
    .rotate(rotateAngle)
    .negate()
    .desaturate(0.4)
    .blacken(0.2)
    .hex() :

    Colorer(oldTheme.colorText)
    .rgb()
    .rotate(rotateAngle - 180)
    // .negate()
    .desaturate(0.4)
    .whiten(0.2)
    .hex();

//  console.log('Colorer(colorText).contrast(Colorer(colorBg) = ', Colorer(colorText).contrast(Colorer(colorBg)));
  // while (Colorer(colorText).contrast(Colorer(colorBg)) < 1) {
  //   colorText = Colorer(textColor).negate().rotate(rotateAngle + 90).hex()
  // //  console.log('Colorer(colorText).contrast(Colorer(colorBg) = ', colorText)
  //     }

  let colorAccentText = (Colorer(colorAccent).isDark()) ? '#FFF' : '#000';
  // debugger;


  let colorTextAlpha = Colorer(colorText).alpha(0.5).string();
//  console.log('colorTextAlpha = ', colorTextAlpha);



  const newColorTheme = {
    colorText: colorText,
    colorAccent: colorAccent,
    colorBg: colorBg,
    colorAccentText: colorAccentText,
  }
  return newColorTheme;
}


export default ColorThemer;